<div class="page-header">
  <label class="page-header-title">
    {{ "pool_parameters.HEADERS.2" | translate }}
  </label>
</div>
<div class="split"></div>
<div class="pool-parameters-container">
  <div class="table-body">

    <!-- TODO: DROPDOWN SELECT COMPONENT -->
    <ng-select [multiple]="false" [items]="zones" bindLabel="zoneName" bindValue="zoneId" class="zone-select"
      [placeholder]="'modals.add_service.zone_input' | translate" [(ngModel)]="activeZone" (close)="filterData()">
    </ng-select>

    <div class="operative-zone-container" *ngIf="activeZone">
      <div class="section-title">
        <img src="/assets/img/tarifas.png" style="width: 19px" />
        {{ "pool_parameters.HEADERS.0" | translate }}
      </div>

      <div class="operative-zone-table">

        <table tuiTable class="custom-table" style="min-width: 685px"
          [style.borderRadius]="sortedDataOperativeZone$ && sortedDataOperativeZone$.value && sortedDataOperativeZone$.value.length > 0 ? '8px': '8px 8px 0px 0px'"
          [columns]="OperativeZoneHeadersKeys" [direction]="(direction$ | async) || 1" [tuiSortBy]="sorter$ | async"
          (directionChange)="direction$.next($event)" (tuiSortByChange)="sorter$.next($event!)">
          <thead>
            <tr tuiThGroup>
              <ng-container *ngFor="let header of OperativeZoneHeaders; trackBy: trackByHeaderTableInfo">
                <ng-container *ngIf="header.Sortable">
                  <th tuiTh *tuiHead="header.Key!" [sticky]="header.Sticky ?? false" [ngClass]="header.Class"
                    tuiSortable>
                    {{ header.Title }}
                  </th>
                </ng-container>
                <ng-container *ngIf="!header.Sortable">
                  <th tuiTh *tuiHead="header.Key!" [sticky]="header.Sticky ?? false" [ngClass]="header.Class"
                    [sorter]="null">
                    {{ header.Title }}
                  </th>
                </ng-container>


              </ng-container>

            </tr>
          </thead>

          <tbody tuiTbody tuiTbody *ngIf="sortedDataOperativeZone$ | async as operativeZoneList">
            <ng-container *ngIf="operativeZoneList.length > 0">
              <tr tuiTr
                *ngFor="let operativeZone of sortedDataOperativeZone$ | async; let index = index;  trackBy: trackByOperativeZoneConfiguration">

                <td *tuiCell="HeaderKey.SERVICE_CONDITIONS" tuiTd>
                  {{ getOperativeZoneDescription(operativeZone.description) }}
                </td>
                <td *tuiCell="HeaderKey.TIME_LIMIT" tuiTd>
                  {{ operativeZone.timeLimit }}
                </td>

                <td *tuiCell="HeaderKey.ACTIONS" tuiTd>
                  <tui-icon (click)="openUpdateOperativeZoneModal(operativeZone, index)" icon="tuiIconEdit2"
                    class="pointer-item action-icon"></tui-icon>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
        <ng-container *ngIf="sortedDataOperativeZone$ | async as operativeZoneList">
          <ng-container *ngIf="operativeZoneList.length === 0">
            <div class="no-data-container">
              <p class="no-data-text">{{ 'pool_parameters.HEADERS.4' | translate }}</p>
            </div>
          </ng-container>
        </ng-container>

      </div>
    </div>

    <app-products-table-parameters [productsDetails]="productsDetails" [activeZone]="activeZone"
      (updateAvailableEmitter)="updateAvailability($event.event, $event.verticalType)"
      (updateSubproductDataEmitter)="updateSubproductData($event)"></app-products-table-parameters>

  </div>
</div>